import React, { Component } from "react";
import loader from "../assets/image/half-circle.gif";
import PdfIcon from "../assets/image/img-pdf-icon.png";
import ReactModal from "react-modal";
import { withTranslation } from "react-i18next";

class MyFCCMoments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      imageUrl: "",
      isWrap: false,
    };
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleOpenModal(e, imageUrl) {
    this.setState({ showModal: true, imageUrl });
  }

  handleCloseModal() {
    this.setState({ showModal: false, imageUrl: "" });
  }

  handleViewAll = (value) => {
    this.setState({ isWrap: value });
  };

  render() {
    const { fccMoments, loading, dataNotFound, t } = this.props;
    const { showModal, imageUrl, isWrap } = this.state;
    let list = [...fccMoments];
    if (!isWrap) {
      if (fccMoments && fccMoments.length) list = list.slice(0, 3);
    } else {
      list = fccMoments;
    }
    return (
      <div className="card" id="myFccMoments">
        <div className="card-header">
          <h3 className="card-header-title">{t("My FCC Moments")}</h3>
          <div>
            {fccMoments.length > 3 ? (
              !isWrap ? (
                <span
                  className="card-header-action"
                  onClick={() => {
                    this.handleViewAll(true);
                  }}
                >
                  View All
                </span>
              ) : (
                <span
                  className="card-header-action"
                  onClick={() => {
                    this.handleViewAll(false);
                  }}
                >
                  View less
                </span>
              )
            ) : null}
          </div>
        </div>
        <div className="card-body card-body-image-list">
          {loading ? (
            <div className="card-loader">
              <img src={loader} alt="loading..." />
            </div>
          ) : dataNotFound ? (
            <div className="card-loader">{t("Data not found")}</div>
          ) : fccMoments && fccMoments.length > 0 ? (
            <div>
              {list &&
                list.map((eachItem, i) => {
                  return (
                    <>
                      {eachItem.fcc_moment_images.length > 0 ? (
                        <div className="card-item-content">
                          <h5 className="card-item-title">
                            {eachItem.caption}
                          </h5>
                          <p className="card-item-info">{eachItem.year}</p>
                        </div>
                      ) : null}
                      <div className="card-list" key={`FCC_images-${i}`}>
                        {eachItem.fcc_moment_images.length > 0
                          ? eachItem.fcc_moment_images.map((eachImage, i) => {
                              return (
                                <div key={i} className="card-item">
                                  <div className="card-item-image">
                                    {eachImage.url &&
                                    eachImage.url.split(".").pop() === "pdf" ? (
                                      <img
                                        src={PdfIcon}
                                        alt="fccMoments"
                                        onClick={() => {
                                          window.open(eachImage.url, "_blank");
                                        }}
                                      />
                                    ) : eachImage.url ? (
                                      <img
                                        src={eachImage.url}
                                        alt="fccMoments"
                                        onClick={(e) =>
                                          this.handleOpenModal(e, eachImage.url)
                                        }
                                      />
                                    ) : null}
                                  </div>
                                </div>
                              );
                            })
                          : null}
                      </div>
                    </>
                  );
                })}
            </div>
          ) : (
            <div className="card-loader">{t("Data not found")}</div>
          )}
        </div>
        <ReactModal
          isOpen={showModal}
          contentLabel="Minimal Modal Example"
          className="Modal modal-preview"
          overlayClassName="Overlay"
          onRequestClose={this.handleCloseModal}
        >
          <img
            src={imageUrl}
            alt="fccMoments"
            className="card-item-image-preview"
          />

          <button onClick={this.handleCloseModal} className="modal-close">
            {" "}
            <i className="fa fa-close"></i>{" "}
          </button>
        </ReactModal>
      </div>
    );
  }
}

export default withTranslation()(MyFCCMoments);
